import { TaggedDataSetReference } from 'libs/end-to-end/src/types/databases/data-sets/data-set-reference';
import { Setter } from 'libs/end-to-end/src/ui-types';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { AdminTable } from 'apps/sigma2-ui/src/components/AdminLayout';
import React from 'react';
import { useTransformDataSetSelector } from 'apps/sigma2-ui/src/data-wizard/lib/useTransformDataSetSelector';

export const TransformDataSetSelector = ({
  organizationId,
  databaseId,
  taggedDataSetReferences,
  setTaggedDataSetReferences,
  isRunningTransform,
}: {
  organizationId: string;
  databaseId: string;
  taggedDataSetReferences: TaggedDataSetReference[];
  setTaggedDataSetReferences: Setter<TaggedDataSetReference[]>;
  isRunningTransform: boolean;
}) => {
  const {
    addDataSetVersionButtonDisabled,
    addDataSetVersionButtonBehavior,
    addDataSetVersionButtonLabel,
    backButtonBehavior,
    backButtonLabel,
    backButtonDisabled,
    modal,
    heading,
    rows,
  } = useTransformDataSetSelector({
    taggedDataSetReferences,
    setTaggedDataSetReferences,
    organizationId,
    databaseId,
    isRunningTransform,
  });
  return (
    <>
      <Spacing size={'md'} direction={'vertical'}>
        <Spacing size="justify-between" direction="horizontal">
          <Button
            behavior={backButtonBehavior}
            text={backButtonLabel}
            disabled={backButtonDisabled}
          />
          <Button
            behavior={addDataSetVersionButtonBehavior}
            text={addDataSetVersionButtonLabel}
            disabled={addDataSetVersionButtonDisabled}
          />
        </Spacing>
        <AdminTable headings={heading} rows={rows} />
      </Spacing>
      {modal}
    </>
  );
};
